import styles from "./Quotes.module.css";
import { useEffect, useState } from "react";
import cn from "classnames";
import { quotes, Quote } from "./content/quotes";
import pageStyles from "./PricingPage.module.css";

export function Quotes() {
  const [containerRef, setContainerRef] = useState<HTMLDivElement | null>(null);
  const [maxHeight, setMaxHeight] = useState(0);

  const [activeQuote, setActiveQuote] = useState(quotes[0]);

  const handleHover = (companyQuote: Quote) => {
    setActiveQuote(companyQuote);
  };

  const { name: active, quote, author } = activeQuote;

  useEffect(() => {
    // Calculate the height of the tallest quote item
    const calculateMaxHeight = () => {
      if (containerRef) {
        const children = Array.from(containerRef.children) as HTMLDivElement[];
        const tallestChildHeight = Math.max(
          ...children.map((child) => child.offsetHeight)
        );
        setMaxHeight(tallestChildHeight);
      }
    };
    calculateMaxHeight();

    // Add event listener for window resize
    window.addEventListener("resize", calculateMaxHeight);

    // Remove event listener on cleanup
    return () => {
      window.removeEventListener("resize", calculateMaxHeight);
    };
  }, [containerRef]);

  return (
    <div
      className={cn(styles.container, pageStyles.sectionCentered)}
      ref={(node) => setContainerRef(node)}
      style={{ minHeight: `${maxHeight + 110}px` }}
    >
      <div className={styles.quotes}>
        {quotes.map((quoteItem) => (
          <div
            key={quoteItem.name}
            className={cn(
              styles.quoteItem,
              active === quoteItem.name && styles.active
            )}
            onMouseEnter={() => handleHover(quoteItem)}
          >
            <div className={styles.image}>
              <img src={quoteItem.image} alt={quoteItem.name} />
            </div>
          </div>
        ))}
      </div>
      <div className={styles.content}>
        <div>{quote}</div>
        <div className={styles.author}>{author}</div>
      </div>
    </div>
  );
}
